import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { AlertService } from 'sce-core';
import { DataTableConfig } from '../../search/models/data-table-config';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { Observable } from 'rxjs/Observable';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT, REFRESH_SEARCH_EVENT, ITEM_CLICK_EVENT, NEW_ROW_EVENT } from '../../search/search-constants';
import { Subscription } from 'rxjs/Subscription';
// tslint:disable-next-line:max-line-length
import { ViewBalancesCellRendererComponent } from '../../components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component';
import { AssignLaneCellRendererComponent } from './assign-lane-cell-renderer/assign-lane-cell-renderer.component';
import { ButtonItem } from '../../button/button.model';
import { SearchCriteria, Clause, Condition } from '../../search/models/search-filter-model';
import { ValidatorService } from '../../services/validator.service';
import { DetailedEntityDataEditorService } from '../../services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { Row } from 'primeng/primeng';
import { PageDefinition } from '../../search/models/page-definition.model';
import { AssignLaneHeaderComponent } from './assign-lane-custom-cell-header/assign-lane-custom-header.component';

@Component({
  selector: 'lfwms-wave-assign-lane-popup',
  templateUrl: './assign-lane-popup.component.html',
  styleUrls: ['./assign-lane-popup.component.css']
})
export class AssignLanePopupComponent implements OnInit, OnDestroy {


  public lookupSearchService: SearchService;
  public parentDataService: any;
  public parentbackendService: any;
  public dataEditor: any;
  public searchEventSubscription: Subscription;
  public detailEventSubscription: Subscription;
  public populateLaneEventSubscription: Subscription;
  public primaryKey: string;
  // search services for landing, detail and populate screen
  public searchSearchService: SearchService;
  public detailSearchService: SearchService;
  public poPulateSearchService: SearchService;
  // find out wether user avigated from load tab or shipref tab
  public primayFlowLoadOrShipref: string = '';
  public resourceService: any;
  public showSearchPage: boolean = false;
  public showDetailPage: boolean = false;
  public showPopulatePage: boolean = false;
  public lblBack: string = '';
  public buttonArray: any[] = [];
  protected validatorService: ValidatorService;
  public maxIdValueForDetailTable: any;
  public confirmDialogService: any;
  public screenType: string;
  // load or mbol key used to navigate to detail page
  public primarySelectedDocument: any;
  // fcaility from landing page
  public primaryFacility: string = '';
  // no on line items selected in populate screen
  public noOfPalletsSelected: any;
  // count of pallets in populate page
  public totalPallets: any;
  // the line item selected to navigate to detail page
  public navigatedLineItemFromSearch: any;

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
    this.lblBack = this.resourceService.get('lbl_agn_back');
    this.validatorService = new ValidatorService(this.alertService, this.resourceService);
  }

  ngOnInit() {
    this.searchEventSubscription = this.lookupSearchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === NEW_SEARCH_EVENT) {
          // here we are manualy creatinting the pinned row for displaying the total
          const pinnedPayload: any = {};
          this.lookupSearchService.getMetadata().columnList.forEach((column: any) => {
            if (column.propertyName === 'totalCarton' || column.propertyName === 'totalPallet'
              || column.propertyName === 'totalLoose') {
              pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: 0 };
            } else {
              pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: '' };
            }
          });
          pinnedPayload['isSelected'] = false;

          if (this.primaryKey === 'loadKey') {
            pinnedPayload['loadKey'] = {
              cName: this.primaryKey,
              cVal: ''
            };
          } else {
            pinnedPayload['mbolKey'] = {
              cName: this.primaryKey,
              cVal: ''
            };
          }

          // this is the method where the pinned row total calculating logic is implemented
          const enrichPayload: any = (data: any) => {
            this.lookupSearchService.pagedData.pageRows.forEach(row => {
              // tslint:disable-next-line:radix
              const totalCarton = parseInt(pinnedPayload['totalCarton']['cVal']) + parseInt(row.cells['totalCarton'].cVal);
              pinnedPayload['totalCarton']['cVal'] = isNaN(totalCarton) ? 0 : totalCarton;
              // tslint:disable-next-line:radix
              const totalPallet = parseInt(pinnedPayload['totalPallet']['cVal']) + parseInt(row.cells['totalPallet'].cVal);
              pinnedPayload['totalPallet']['cVal'] = isNaN(totalPallet) ? 0 : totalPallet;
              // tslint:disable-next-line:radix
              const totalLoose = parseInt(pinnedPayload['totalLoose']['cVal']) + parseInt(row.cells['totalLoose'].cVal);
              pinnedPayload['totalLoose']['cVal'] = isNaN(totalLoose) ? 0 : totalLoose;
            });
          };
          enrichPayload(this.lookupSearchService.pagedData.pageRows);
          this.lookupSearchService.getPagedData().pinnedPageRows = [pinnedPayload];
          this.lookupSearchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        } else if ($event.type === ITEM_CLICK_EVENT) {
          this.navigateToDetailPage($event.selectedItemId);
        }
      });
    this.buttonArray = [
      new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'assign_lane_edit', 'pencil', []),
      new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
      new ButtonItem('Delete', this.resourceService.get('btn_delete'), 'assign_lane_del', 'trash', []),
      new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'assign_lane_add', 'plus-circle', []),
      new ButtonItem('Populate Lane', this.resourceService.get('lbl_pop_lane'), 'assign_lane_pop_ln', 'icon-populate-lane.svg', []),
      // [LFWM-2909][Implementing Sorting Lane Calculation Feature][Don't change the position of Sorting Lane button as it is used for enable and disable]
      new ButtonItem('Sorting Lane Calculation', this.resourceService.get('lbl_sort_lane'), 'assign_lane_sort_lane', 'icon-sort-lane-calculation.svg', []),
    ];
  }

  // initialization for the search page logic
  public initializeComponents(primaryFlow: string, dataService: any, backendService: any, facility: string, screenType?: string) {
    /* Data editor is needed  for searching in tableheader filter */
    this.parentDataService = dataService;
    this.primaryFacility = facility;
    this.parentbackendService = backendService;
    this.primayFlowLoadOrShipref = primaryFlow;
    this.screenType = screenType;
    this.primaryKey = this.primayFlowLoadOrShipref === 'load' ? 'loadKey' : 'mbolKey';
    const tableId = this.primayFlowLoadOrShipref === 'load' ? 'loadplanlanetd' : 'mbollanetd';
    this.searchSearchService = this.createSearchService(tableId);
    this.searchSearchService.setSearchCriteria(this.createSearchCriteriaForSearchPage(this.primaryKey));
    this.lookupSearchService = this.searchSearchService;
    this.showSearchPage = true;
    this.showDetailPage = false;
    this.showPopulatePage = false;
    this.lookupSearchService.searchParams.dataTableConfig.indexColumnVisible = false;
    this.lookupSearchService.searchParams.dataTableConfig.specialWidthColumn
      = ['noOfLane'];
    this.lookupSearchService.searchParams.dataTableConfig.specialWidthDetails = {
      'noOfLane': 50,
    };
    this.lookupSearchService.searchParams.dataTableConfig.columnHeaderMapping['noOfLane'] = AssignLaneHeaderComponent;
    this.lookupSearchService.searchParams.dataTableConfig.columnPinnedRendererMapping[this.primaryKey]
      = ViewBalancesCellRendererComponent;
    const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.lookupSearchService.searchParams.tableEditor = tableEditor;
    this.lookupSearchService.fetchMetadata().subscribe((metaData: any) => {
      this.lookupSearchService.performSearch();
    });
  }

  /**
   *  method used to create default search criteria for search page( loadkey/ mbol )
   * @param primaryKey
   */
  private createSearchCriteriaForSearchPage(primaryKey) {
    const searchServiceTabName = primaryKey === 'loadKey' ? 'loadTabSearchService' : 'shiprefTabSearchService';
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isMandatory = false;
    defaultCondition1.operator = 'AND';
    const defaultClause1 = new Clause();
    defaultClause1.column = primaryKey;
    if (this.screenType !== 'shipRef') {
      defaultClause1.value = this.parentDataService[searchServiceTabName].pagedData.pageRows[0].cells[primaryKey].cVal;
    } else {
      defaultClause1.value = this.parentDataService.primaryDataMap[primaryKey].cVal;
    }
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = null;
    defaultCondition1.clauses = [defaultClause1];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }

  // common search service creation method for search, detail, popultelane screen
  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    if (tableId === 'loadplanlanetd' || tableId === 'mbollanetd') {
      const loadOrShipref: any = this.primayFlowLoadOrShipref === 'load' ? 'loadKey' : 'mbolKey';
      tableConfig.columnRendererMapping[loadOrShipref] = AssignLaneCellRendererComponent;
    } else if (tableId === 'loadplanlanedettd' || tableId === 'mbollanedettd') {
      // LFWM-3191-fix to load buttons by privilege in popups.
      searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonArray);
      tableConfig.editable = true;
      searchParams.idProperty = 'laneId';
    }
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.alertService;
    searchParams.tableEditor = this.dataEditor;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    return searchService;
  }

  /**
   * When an item is clicked we need to navigate to the corresponding Detail page
   */
  public navigateToDetailPage(SelectedDocument: string) {
    // [LFWM-2909][To disable the Sorting Lane button if the value of hasRights obtained from the response is'N']

    // [LFWM-3371] Condition added to always assign lane detail
    let storerKey: any;
    // LFWM-3191- adding tableId
    let tableId: any;
    if (this.parentDataService.waveTabOrdersSearchService) {
      storerKey = this.parentDataService.waveTabOrdersSearchService.pagedData.pageRows[0].cells['storerKey'].cVal;
      tableId = this.parentDataService.waveTabOrdersSearchService.searchParams.tableId;
    } else {
      storerKey = this.parentDataService.detailsSearchService.pagedData.pageRows[0].cells['storerKey'].cVal;
      tableId = this.parentDataService.primarySearchParams.tableId;
    }
    const configKey = 'VFLaneControl';
    this.parentbackendService.validationForFields(configKey, storerKey, tableId)
      .subscribe((response: any) => {
        if (response['hasRights'] === 'N') {
          this.buttonArray[5].isEnabled = false;
          this.buttonArray[5].isVisible = false;
        }
      });
    // selected loadkey or mbolkey
    this.primarySelectedDocument = SelectedDocument;
    // we need to reset popu header name which is accessed from coreServiceRegistry.modalService
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader =
      this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader + ' / ' + this.primarySelectedDocument;
    // based on load or ship flow tableId is decided
    const detailTableId = this.primayFlowLoadOrShipref === 'load' ? 'loadplanlanedettd' : 'mbollanedettd';
    this.detailSearchService = this.createSearchService(detailTableId);
    this.showSearchPage = false;
    this.showDetailPage = true;
    this.showPopulatePage = false;
    const loadOrShiprefPrimaryKey = this.primayFlowLoadOrShipref === 'load' ? 'loadKey' : 'mbolKey';
    // below loop is to retrieve selected loadkey's or shipref's key lineitem
    // which is to be used for populating the search criteria
    this.navigatedLineItemFromSearch = this.searchSearchService.pagedData.pageRows
      .filter((row) => (row.cells[loadOrShiprefPrimaryKey].cVal === this.primarySelectedDocument))[0];
    const searchCriteria = this.createSearchCriteria(loadOrShiprefPrimaryKey, this.navigatedLineItemFromSearch);
    const tableEditor: DetailedEntityDataEditorService = new DetailedEntityDataEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.detailSearchService.searchParams.tableEditor = tableEditor;
    // set the search criteria
    this.detailSearchService.setSearchCriteria(searchCriteria);
    // metadata and loadby page call is done
    this.detailSearchService.fetchMetadata().subscribe((metadata) => {
      this.detailSearchService.performSearch();
    });
    // used to enable buttons based on edit or view mode
    this.enableButton('Edit');
    // on Add new line item loadkey, shiprefkey, externOrderKey, consigneeKey should be auto populated
    this.detailEventSubscription = this.detailSearchService.receiveEvent().subscribe((event) => {
      if (event.type === NEW_ROW_EVENT) {
        event.selectedRow.cells[loadOrShiprefPrimaryKey].cVal = this.navigatedLineItemFromSearch.cells[loadOrShiprefPrimaryKey].cVal;
        event.selectedRow.cells['externOrderKey'].cVal = this.navigatedLineItemFromSearch.cells['externOrderKey'].cVal;
        event.selectedRow.cells['consigneeKey'].cVal = this.navigatedLineItemFromSearch.cells['consigneeKey'].cVal;
        this.handleAddNewLineItem(event);
      }
    });

  }

  /**
   * this method has the auto generation of primarId line number logic
   * @param event
   */
  public handleAddNewLineItem(event) {
    const pageDefinition: PageDefinition = this.detailSearchService.getPagedData().pageDefinition;


    this.detailSearchService.getMaxValueForIdProperty().subscribe((response: any) => {
      if (response && response.propertyValues && response.propertyValues.length > 0) {
        this.maxIdValueForDetailTable = response.propertyValues[0].cVal;
        this.initializeValuesForNewLineItem(event.selectedRow, this.maxIdValueForDetailTable);
        this.detailSearchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
      }
    });
    if (this.detailSearchService.getPagedData().pageRows.length >= pageDefinition.pageSize) {
      // if the current page has overflown, clear the max value so that it can be refetched in the next page
      this.maxIdValueForDetailTable = null;
    }

  }

  /**
   * decide the primaryID line number
   * @param newRow
   * @param maxIdValueForDetailTable
   */
  public initializeValuesForNewLineItem(newRow, maxIdValueForDetailTable) {
    let maxValue: string = '00000';
    const idProperty = 'laneId';
    this.detailSearchService.getPagedData().pageRows.forEach((row: any) => {
      if (!maxValue || maxValue < row.cells[idProperty].cVal) {
        maxValue = row.cells[idProperty].cVal;
      }
    });
    if (maxIdValueForDetailTable && maxValue < maxIdValueForDetailTable) {
      maxValue = maxIdValueForDetailTable;
    }
    const newLineNumber = (+maxValue) + 1;
    let newLineNoStr = '' + newLineNumber;
    while (newLineNoStr.length < 5) {
      newLineNoStr = '0' + newLineNoStr;
    }
    newRow.cells[idProperty].cVal = newLineNoStr;
  }

  /**
   * create search criteria for details page based on loadkey, shiprefkey, externOrderKey, consigneeKey
   * @param primaryKey
   * @param lineItem
   */
  public createSearchCriteria(primaryKey: string, lineItem: any) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isMandatory = false;
    defaultCondition1.operator = 'AND';
    const defaultClause1 = new Clause();
    defaultClause1.column = primaryKey;
    defaultClause1.value = lineItem.cells[primaryKey].cVal;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = null;
    const defaultClause2 = new Clause();
    defaultClause2.column = 'externOrderKey';
    defaultClause2.value = lineItem.cells[defaultClause2.column].cVal;
    defaultClause2.operation = '=';
    defaultClause2.logicalOperation = 'AND';
    const defaultClause3 = new Clause();
    defaultClause3.column = 'consigneeKey';
    defaultClause3.value = lineItem.cells[defaultClause3.column].cVal;
    defaultClause3.operation = '=';
    defaultClause3.logicalOperation = 'AND';
    defaultCondition1.clauses = [defaultClause1, defaultClause2, defaultClause3];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  /**
   * create an instance of condition
   * @param id
   */
  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }

  /**
   * method allows us to navigate from detail page to search page
   */
  public backToSearchPage() {
    this.lookupSearchService.performSearch();
    this.showDetailPage = false;
    this.showSearchPage = true;
    this.showPopulatePage = false;
    // on navigation need to change popup component title
    const popupTitle = this.resourceService.get('lbl_pop_assign_lane_header');
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader = popupTitle;
  }

  /**
   * enabling button based on edit or viewmode
   * @param buttonId
   */
  private enableButton(buttonId: string) {
    const showEdit = buttonId === 'Edit' ? true : false;
    this.buttonArray[0].isEnabled = showEdit;
    this.buttonArray[0].isVisible = showEdit;
    this.buttonArray[1].isEnabled = !showEdit;
    this.buttonArray[1].isVisible = !showEdit;
    this.buttonArray[3].isEnabled = !showEdit;
    this.buttonArray[3].isVisible = !showEdit;
  }

  /**
   * handle button actions from detail page
   * @param action
   */
  public handleButtonAction(action: string) {
    if (action === 'Edit') {
      this.detailSearchService.setDisplayMode('E');
      this.enableButton('Save');
      // this.lookupSearchService.searchParams.actionButtons = this.buttonArrayForEditMode;
      // LFWM-3191- made a new api /withPriv (replacement for setup api)
      //  to pass the privileges for checking the privileges at the backend level.
    } else if (action === 'Save') {
      const savePopupPrivilegeList = ['assign_lane_edit', 'assign_lane_add'];
      let privilege: any;
      const lineItems = this.detailSearchService.getEditedRows();
      let requestItems: Array<any>;
      // adding the warning so as to avoid saving when no modifications are done to the entity and trying to save.
      if (lineItems.length === 0) {
        const errorMsg: string = 'msg_no_mod';
        this.alertService.clearAll().warn(this.resourceService.get(errorMsg));
        this.detailSearchService.clearMarkerFlags();
        this.detailSearchService.setDisplayMode('V');
        this.enableButton('Edit');
        return;
      }
      // LFWM-3191- corresponding privileges are assigned to user action Edit/addrow
      lineItems.forEach(item => {
        if (item.isNewRow === true) {
          privilege = savePopupPrivilegeList.filter((itemAdd: any) => {
            return itemAdd.endsWith('_add');
          });
        }else {
          privilege = savePopupPrivilegeList.filter((itemEdit: any) => {
            return itemEdit.endsWith('_edit');
          });
        }
      });
      // format the modified line items in the required request format
      requestItems = this.getCellValuesList(lineItems, privilege[0]);
      // added to validate mandatory fields
      if (this.validateUserEnteredData()) {
        const saveObj: Observable<any> = this.saveAssigneLane(requestItems);
        if (saveObj) {
          saveObj.subscribe((response) => {
            if (response.statusCode === 200) {
              // If there are line items in details page
              if (this.detailSearchService.pagedData.pageRows.length > 0) {
                this.detailSearchService.clearMarkerFlags();

              }
              this.detailSearchService.performSearch();
              const successMsg = 'msg_save_succ';
              this.alertService.clearAll().success(this.resourceService.get(successMsg));
              this.detailSearchService.setDisplayMode('V');
              this.enableButton('Edit');
            } else {
              this.alertService.clearAll();
              this.alertService.error(this.resourceService.get(response.statusMessage));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
      }
    } else if (action === 'Delete') {
      const noOfLineItems: any = this.detailSearchService.pagedData.pageDefinition.recordCount;
      const selectedRows: any[] = this.detailSearchService.getSelectedRows();
      const requestArray: any[] = [];
      const privilege = 'assign_lane_del';
      if (noOfLineItems === 0) {
        const errorMsg = 'msg_no_detail';
        this.alertService.clearAll().error(this.resourceService.get(errorMsg));
        return;
      }
      if (selectedRows.length > 0) {
        const dialogMsg = 'qn_rem_asgn_lane_det_item';
        this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
          .subscribe((isConfirmed: any) => {
            if (isConfirmed) {
              selectedRows.forEach(Row => {
                const reqObj = {
                  'screenType': this.detailSearchService.searchParams.tableId,
                  'moduleProperties': [],
                  'privilege': privilege
                };
                Object.keys(Row.cells).forEach(colName => {
                  const colObj = {
                    'cName': colName,
                    'cVal': Row.cells[colName].cVal
                  };
                  reqObj.moduleProperties.push(colObj);
                });
                requestArray.push(reqObj);
              });
              // LFWM-3191- made a new api /withPriv (replacement for setup api)
              //  to pass the privileges for checking the privileges at the backend level.
              this.parentbackendService.removeWaveOrderswithPrivilege(requestArray)
                .subscribe((resp: any) => {
                  if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
                    if (resp['statusCode'] === 0) {
                      const successMsg = 'msg_del_itm_succ';
                      this.alertService.clearAll();
                      this.alertService.success(this.resourceService.get(successMsg));
                      this.detailSearchService.performSearch();
                    } else if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                      // code to reload the asn detail grid
                      const successMsg = 'msg_del_itm_succ';
                      this.alertService.clearAll();
                      this.alertService.success(this.resourceService.get(successMsg));
                      this.detailSearchService.performSearch();
                    } else {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  } else {
                    if (resp.error) {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  }
                }, (error) => {
                  this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
                });
            }
          });
      } else {
        this.alertService.clearAll();
        this.alertService.error(this.resourceService.get('msg_sel_detail'));
      }
    } else if (action === 'Populate Lane') {
      const lanepopulateTableId: string = 'poplanetd';
      this.poPulateSearchService = this.createSearchService(lanepopulateTableId);
      const searchCriteria = this.createDefaultSearchCriteriaForPopulateLane();
      this.poPulateSearchService.setSearchCriteria(searchCriteria);
      this.showSearchPage = false;
      this.showDetailPage = false;
      this.showPopulatePage = true;
      // [LFWM-2909][Implementing Sorting Lane Calculation Feature]
    } else if (action === 'Sorting Lane Calculation') {
      const requestObj: any = {
        'loadKey': this.navigatedLineItemFromSearch.cells['loadKey'] ? this.navigatedLineItemFromSearch.cells['loadKey'].cVal : '',
      };
      this.parentbackendService.sortLane(requestObj).subscribe((resp: any) => {
        if (resp.statusCode === 200) {
          this.alertService.clearAll().success(this.resourceService.get(resp.statusMessage));
        } else {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.get(resp.statusMessage));
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
    }
  }

  /**
   * this method is bind in the template to get total sum of pallets from selected line item
   */
  public getTotalOfSeletedPallets() {
    let total = 0;
    const selectedRows: any[] = this.poPulateSearchService.getSelectedRows();
    if (selectedRows.length > 0) {
      selectedRows.forEach(row => {
        total = total + parseInt(row.cells['maxpallet'].cVal, 10);
      });
    } else {
      total = 0;
    }
    return total;
  }



  /**
   * create Default Search Criteria For Populate Lane popup
   * where facility and type should be auto populated
   */
  public createDefaultSearchCriteriaForPopulateLane() {
    const locationCategory = this.primayFlowLoadOrShipref === 'load' ? 'HVCP' : 'Staging';
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    // first search condition for locationCategory
    const locategoryCondition = this.createDefaultSearchCondition(1);
    locategoryCondition.isReadOnly = false;
    locategoryCondition.isMandatory = false;
    const loccategoryClause = new Clause();
    loccategoryClause.operation = '=';
    loccategoryClause.column = 'locationCategory';
    loccategoryClause.value = locationCategory;
    locategoryCondition.clauses = [loccategoryClause];
    locategoryCondition.operator = 'AND';
    // first search condition for facility
    const facilityCondition = this.createDefaultSearchCondition(2);
    facilityCondition.isReadOnly = false;
    facilityCondition.isMandatory = false;
    const facilityClause = new Clause();
    facilityClause.operation = '=';
    facilityClause.column = 'facility';
    facilityClause.value = this.primaryFacility;
    facilityCondition.clauses = [facilityClause];
    facilityCondition.operator = 'AND';
    defaultSearchCriteria.conditions = [locategoryCondition, facilityCondition];

    return defaultSearchCriteria;
  }

  /**
   * this is uesed to populate the selected lanes to detail page
   */
  public populateAssignLane() {
    const AllLineItem: any[] = this.poPulateSearchService.getAllRows();
    const selectedRows = this.poPulateSearchService.getSelectedRows();
    // chect wether there is line item present
    if (AllLineItem.length === 0) {
      const errorMsg = 'msg_no_detail';
      this.alertService.clearAll().error(this.resourceService.get(errorMsg));
      return;
    }
    // check that user needs to select atleast one item to populate
    if (selectedRows.length === 0) {
      const errMsg: string = 'msg_sel_one_lane';
      this.alertService.clearAll().error(this.resourceService.get(errMsg));
      return;
    }
    // creating request array
    const requestArray: any[] = [];
    selectedRows.forEach(row => {
      const requestObj: any = {
        'locationCategory': row.cells['locationCategory'].cVal,
        'loc': row.cells['loc'].cVal,
        'loadkey': this.navigatedLineItemFromSearch.cells['loadKey'] ? this.navigatedLineItemFromSearch.cells['loadKey'].cVal : '',
        'mbolkey': this.navigatedLineItemFromSearch.cells['mbolKey'] ? this.navigatedLineItemFromSearch.cells['mbolKey'].cVal : '',
        'externOrderkey': this.navigatedLineItemFromSearch.cells['externOrderKey'].cVal,
        'consigneekey': this.navigatedLineItemFromSearch.cells['consigneeKey'].cVal
      };
      requestArray.push(requestObj);
    });

    this.parentbackendService.populateAssignLane(requestArray).subscribe((resp: any) => {
      let populateLaneResponses: any;
      // handle multiple response from wrapper
      if (resp.populateLaneResponses && resp.populateLaneResponses.length > 0) {
        populateLaneResponses = resp.populateLaneResponses;
        const errMsgArray: any[] = [];
        populateLaneResponses.forEach(laneResponse => {
          if (laneResponse['statusCode'] && laneResponse['statusMessage']) {
            if (laneResponse['statusCode'] === 200) {
              let successMsg: string = 'msg_pop_lane_succ';
              // handler for error msg on success code
              if (laneResponse['errMsg']) {
                successMsg = resp['errMsg'];
              }
              this.alertService.success(this.resourceService.get(successMsg));
            } else {
              const errMsgcancel: string = 'pop_lane_fail_type';
              const errMsg: string = this.resourceService.get(errMsgcancel) + ' '
                + laneResponse['locationCategory'] + ' ' + this.resourceService.get('pop_lane_fail_loc') + ' ' + laneResponse['loc'] + '- '
                + laneResponse['errMsg'] || laneResponse['statusMessage'];
              errMsgArray.push(errMsg);
            }
          } else {
            if (laneResponse.error) {
              this.alertService.error(this.resourceService.translateServerResponse(laneResponse.error));
            }
          }
        });
        if (errMsgArray.length > 0) {
          this.alertService.error(errMsgArray);
        }
        this.showSearchPage = false;
        this.showDetailPage = true;
        this.showPopulatePage = false;
        this.detailSearchService.performSearch();
      } else {
        populateLaneResponses = resp;
        if (populateLaneResponses['statusCode'] && populateLaneResponses['statusMessage']) {
          if (populateLaneResponses['statusCode'] === 200) {
            const successMsg: string = 'msg_pop_lane_succ';
            this.alertService.success(this.resourceService.get(successMsg));
          } else {
            const errMsg: string = populateLaneResponses['errMsg'] || populateLaneResponses['statusMessage'];
            this.alertService.clearAll().error(errMsg);
          }
        } else {
          if (populateLaneResponses.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(populateLaneResponses.error));
          }
        }
      }
    }, (error) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });

  }

  /**
   * from the populate screen navigate back to detail page
   */
  public backToDetailPage() {
    this.showDetailPage = true;
    this.showSearchPage = false;
    this.showPopulatePage = false;
    this.detailSearchService.performSearch();
    const popupTitle = this.resourceService.get('lbl_pop_assign_lane_header');
    // we need to reset popup header name which is accessed from coreServiceRegistry.modalService
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader =
      popupTitle + ' / ' + this.primarySelectedDocument;
  }


  /**
   * this is the method where request structure is formed for save activity
   * @param modifiedLineItems
   */
  protected getCellValuesList(modifiedLineItems, privilege: any) {
    const requestList: Array<any> = [];
    let selectedLineItem: any;
    modifiedLineItems.forEach((row: any, index: any) => {
      selectedLineItem = [];
      const isNewItem: boolean = (row.cells['isNewItem'] && row.cells['isNewItem'].cVal) ? true : false;
      let typeName = '';
      if (!isNewItem) {
        typeName = 'original_';
      }
      Object.keys(row.cells).forEach((property: any) => {
        const cell = row.cells[property];
        if ((cell.cValOrig !== undefined) && (cell.cValOrig !== cell.cVal)) {
          selectedLineItem.push({ cName: typeName + property, cVal: cell.cValOrig });
          selectedLineItem.push({ cName: property, cVal: cell.cVal });
        } else {
          selectedLineItem.push({ cName: typeName + property, cVal: cell.cVal });
        }
      });
      const request = {
        'moduleProperties': selectedLineItem,
        'screenType': this.detailSearchService.searchParams.tableId,
        'privilege': privilege
      };
      requestList.push(request);
    });


    return requestList;
  }

  /**
   * validation before save
   */
  public validateUserEnteredData() {
    // added to validate the fields of line items
    const validateLineItemsErr = this.validatorService.validateMultipleRows(this.detailSearchService.
      getMetadata(), this.detailSearchService.getPagedData());
    if (validateLineItemsErr) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * backend call for save activity
   * @param response
   */
  public saveAssigneLane(response): Observable<any> {
    return this.parentbackendService.saveAssignLaneDetails(response)
      .map((saveAssignLaneResponse: any) => {
        return saveAssignLaneResponse;
      });
  }

  /**
   * memory cleanup logic
   */
  public ngOnDestroy() {
    if (this.searchEventSubscription) {
      this.searchEventSubscription.unsubscribe();
    }
    if (this.detailEventSubscription) {
      this.detailEventSubscription.unsubscribe();
    }
    this.searchSearchService = null;
    this.detailSearchService = null;
  }
}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/assign-lane-popup/assign-lane-popup.component.ts